import { z } from 'zod';

// Schemas (source of truth)
export const issuesSortingSettingsSchema = z.object({
	projectId: z.string(),
	byProfession: z.array(z.string()).optional(),
	byAssignee: z.array(z.string()).optional(),
});

// Types (derived from schemas)
export type IIssuesSortingSettings = z.infer<typeof issuesSortingSettingsSchema>;
